export const routes = ( prefix ) => [
    {
        path: `/${prefix}/theatres/service-packages`,
        name: `${prefix}.theatres.service-packages.index`,
        component: () => import('./service-packages/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.theatres.service-packages.index`,
                PageDescription: "Theatre Service Package listing",
            },
        },
    },
    {
        path: `/${prefix}/theatres/rooms`,
        name: `${prefix}.theatres.rooms.index`,
        component: () => import('./rooms/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.theatres.rooms.index`,
                PageDescription: "Theatre Room listing",
            },
        },
    },
    {
        path: `/${prefix}/theatres/procedure-pricing`,
        name: `${prefix}.theatres.procedure-pricing.index`,
        component: () => import('./procedure-prices/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.theatres.procedure-pricing.index`,
                PageDescription: "Theatre: Procedure pricing",
            },
        },
    },
];
